import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-stars',
  templateUrl: './stars.component.html',
  styleUrls: ['./stars.component.css'],
})
export class StarsComponent implements OnInit {
  @Input() value: number = 0;
  @Input() invalidAnswer: boolean = false;
  @Output() selectedValue = new EventEmitter<number>();

  constructor() {}

  ngOnInit(): void {}

  onClick(index: number): void {
    this.value = index;
    this.selectedValue.emit(index);
  }

  isSelected(index: number): boolean {
    return this.value === index;
  }

  isStarFilled(starIndex: number): boolean {
    // starIndex va de 1 a 5
    return this.value > 0 && starIndex <= this.value;
  }

  getProhibitedClass(): string {
    if (this.value === 0) {
      return 'prohibited-selected';
    }
    return '';
  }

  getStarClass(starIndex: number): string {
    if (this.isStarFilled(starIndex)) {
      return 'star-selected';
    }
    return '';
  }

  getErrorClass(): string {
    if (this.invalidAnswer) {
      return this.value === 0 ? 'error-prohibited' : 'error-stars';
    }
    return '';
  }
}
